var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n  "+_vm._s(_vm.lead)+"\n\t")])}
var staticRenderFns = []

export { render, staticRenderFns }